'use client';
import { useMediaQuery } from 'react-responsive';
export default useMediaQuery;
